import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { PRACTICES } from "../../data/marketing";

export default function PracticePagination({ currentSlug }) {
  const index = PRACTICES.findIndex((p) => p.slug === currentSlug);
  const previous = PRACTICES[(index - 1 + PRACTICES.length) % PRACTICES.length];
  const next = PRACTICES[(index + 1) % PRACTICES.length];

  return (
    <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6" data-testid="practice-pagination">
      <div className="grid gap-4 md:grid-cols-2">
        <Link to={`/practice/${previous.slug}`} className="group rounded-3xl border border-forest-deep/10 bg-white p-6 transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-forest-deep/10" data-testid="practice-prev-link">
          <span className="inline-flex items-center gap-2 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-forest-primary"><ArrowLeft className="h-3.5 w-3.5" /> Previous practice</span>
          <span className="mt-3 block font-display text-2xl font-medium text-forest-deep">{previous.title}</span>
          <span className="mt-2 block text-sm text-forest-deep/55">{previous.summary}</span>
        </Link>
        <Link to={`/practice/${next.slug}`} className="group rounded-3xl border border-forest-deep/10 bg-forest-deep p-6 text-[#FBF9F4] transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-forest-deep/20" data-testid="practice-next-link">
          <span className="inline-flex items-center gap-2 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-emerald-300">Next practice <ArrowRight className="h-3.5 w-3.5" /></span>
          <span className="mt-3 block font-display text-2xl font-medium">{next.title}</span>
          <span className="mt-2 block text-sm text-emerald-100/60">{next.summary}</span>
        </Link>
      </div>
    </section>
  );
}
